<div class="cardModal">
    <div class="cardTitle">
        <h3>{{ (data.id ? 'users.accessGroups.createEdit.editHeader' : 'users.accessGroups.createEdit.createHeader') | translate }}</h3>
    </div>

    <div class="cardContent">
        <!--                <app-loader [type]="'overlayAndSpinner'" [matchAny]="true"/>-->
        @if (accessGroup) {
            <form [formGroup]="editAccessGroupForm">
                @if (userIsAdmin) {
                    <div class="inputGroup">
                        <label for="companyName">{{ 'users.userGroups.createEdit.companyName' | translate }}</label>
                        <div class="inputWrapper">
                            <app-form-error [parentForm]="editAccessGroupForm" [controlPath]="'companyName'" />
                            <select id="companyName" formControlName="companyName">
                                <option [value]="accessGroup.supplierId">{{ accessGroup.companyName }}</option>
                            </select>
                        </div>
                    </div>
                }
                <div class="inputGroup">
                    <label for="name">{{ 'users.accessGroups.createEdit.accessGroupName' | translate }}</label>
                    <div class="inputWrapper">
                        <app-form-error [parentForm]="editAccessGroupForm" [controlPath]="'name'" />
                        <input type="text" formControlName="name" id="name" trimInput />
                    </div>
                </div>
                @if (accessGroupFilters && accessGroupFilters.listings.length) {
                    <div class="multiSelectFilters">
                        <h3>{{ 'users.accessGroups.createEdit.brandsAndCountriesLabel' | translate }}</h3>
                        <div class="inputGroup labelTop">
                            <label for="brands">{{ 'users.accessGroups.createEdit.brandsLabel' | translate }}</label>
                            <div class="inputWrapper">
                                <app-multi-select-input
                                    formControlName="brands"
                                    id="brands"
                                    [optionsList]="accessGroupFilters.brands"
                                    [idKey]="'id'"
                                    [labelKey]="'displayText'"
                                />
                            </div>
                        </div>
                        <div class="inputGroup labelTop">
                            <label for="countries">{{ 'users.accessGroups.createEdit.countriesLabel' | translate }}</label>
                            <div class="inputWrapper">
                                <app-multi-select-input
                                    formControlName="countries"
                                    id="countries"
                                    [optionsList]="accessGroupFilters.countries"
                                    [idKey]="'id'"
                                    [labelKey]="'displayText'"
                                />
                            </div>
                        </div>
                        <div class="multiSelectFilters">
                            <button class="button secondary" (click)="showListingsFilter = !showListingsFilter">
                                {{ 'users.accessGroups.createEdit.addExtraListings' | translate }}
                            </button>
                            @if (showListingsFilter) {
                                <div class="inputGroup labelTop">
                                    <label for="listings">{{ 'users.accessGroups.createEdit.listingsLabel' | translate }}</label>
                                    <div class="inputWrapper">
                                        <app-multi-select-input
                                            formControlName="listings"
                                            id="listings"
                                            [dynamicOptions]="dynamicOptions"
                                            [idKey]="'id'"
                                            [labelKey]="'name'"
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                } @else {
                    <div class="infoNotification">
                        <i class="fa-solid fa-circle-info"></i>
                        <span class="label">
                            {{ 'users.accessGroups.createEdit.noListingsYetHint' | translate }}
                        </span>
                    </div>
                }
                <app-form-error [parentForm]="editAccessGroupForm" [showError]="showFormError" />
            </form>
        }
    </div>
    <div class="cardFooter">
        <footer class="buttonArea stickyBottom centeredButtons">
            @if (accessGroupFilters && accessGroupFilters.listings.length) {
                <button type="submit" class="button primary" (click)="updateAccessGroup()">
                    {{ 'users.accessGroups.createEdit.updateAccessGroup' | translate }}
                </button>
            }
            <button type="button" class="button" (click)="closeModal(false)">
                {{ 'users.accessGroups.createEdit.updateAccessGroupCancel' | translate }}
            </button>
        </footer>
    </div>
</div>
